export const MAX_PGN_BYTES = 3 * 1024 * 1024;
export const MAX_PGN_LABEL = '۳ مگابایت';

export function pgnByteLength(value) {
  return new Blob([String(value ?? '')]).size;
}

export async function readPgnFile(file) {
  if (!file) throw new PgnImportError('file_missing', 'فایلی انتخاب نشده است.');
  if (file.size > MAX_PGN_BYTES) {
    throw new PgnImportError(
      'file_too_large',
      `حجم فایل «${file.name || 'PGN'}» بیشتر از ${MAX_PGN_LABEL} است.`
    );
  }
  return file.text();
}

export function parsePgnAsync(source, { onProgress } = {}) {
  const text = String(source ?? '');
  if (!text.trim()) {
    return Promise.reject(new PgnImportError('pgn_empty', 'متن PGN خالی است.'));
  }
  if (pgnByteLength(text) > MAX_PGN_BYTES) {
    return Promise.reject(new PgnImportError(
      'file_too_large',
      `حجم متن PGN بیشتر از ${MAX_PGN_LABEL} است.`
    ));
  }

  const workerUrl = new URL('./pgn-import-worker.js', import.meta.url);
  return new Promise((resolve, reject) => {
    const worker = new Worker(workerUrl, { type: 'module', name: 'kishmat-pgn-reader' });
    const timeout = window.setTimeout(() => {
      worker.terminate();
      reject(new PgnImportError('reader_timeout', 'خواندن فایل بیش از حد طول کشید؛ فایل را بررسی و دوباره تلاش کنید.'));
    }, 120_000);

    worker.addEventListener('message', event => {
      if (event.data?.type === 'progress') {
        onProgress?.(Number(event.data.completed) || 0, Number(event.data.total) || 0);
        return;
      }
      if (event.data?.type !== 'complete') return;
      window.clearTimeout(timeout);
      worker.terminate();
      resolve(event.data.result);
    });
    worker.addEventListener('error', () => {
      window.clearTimeout(timeout);
      worker.terminate();
      reject(new PgnImportError('reader_failed', 'مرورگر نتوانست فایل PGN را بخواند.'));
    }, { once: true });
    worker.postMessage({ source: text });
  });
}

export class PgnImportError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'PgnImportError';
    this.code = code;
  }
}
